export { ChemicalsAccordion } from './ChemicalsAccordion.component';
